import { buildInputSearchOptionStyles } from './variantStyles/inputSearch';
import { buildSelectorRowDefaultOptionStyles } from './variantStyles/selectorRowDefault';
import { buildSelectorRowUserOptionStyles } from './variantStyles/selectorRowUser';
import { buildSelectorRowWithCheckboxOptionStyles } from './variantStyles/selectorRowWithCheckbox';
import { buildSelectorRowWithToggleOptionStyles } from './variantStyles/selectorRowWithToggle';
import { OptionVariantType } from './variants';
export const getOptionsStyles = (FOUNDATIONS, FONT) => ({
    [OptionVariantType.SELECTOR_ROW_DEFAULT]: buildSelectorRowDefaultOptionStyles(FOUNDATIONS),
    [OptionVariantType.SELECTOR_ROW_USER]: buildSelectorRowUserOptionStyles(FOUNDATIONS),
    [OptionVariantType.SELECTOR_ROW_WITH_TOGGLE]: buildSelectorRowWithToggleOptionStyles(FOUNDATIONS),
    [OptionVariantType.SELECTOR_ROW_WITH_CHECKBOX]: buildSelectorRowWithCheckboxOptionStyles(FOUNDATIONS),
    [OptionVariantType.INPUT_SEARCH]: buildInputSearchOptionStyles(FOUNDATIONS),
});
//# sourceMappingURL=styles.js.map